






























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IFiltersOptions } from "@/models/tables";
import { FilterTypes } from "@/data/table";

@Component({
  components: {
    "string-filter": () =>
      import("@/components/app/global/dataFilters/stringFilter.vue"),
    "number-filter": () =>
      import("@/components/app/global/dataFilters/numberFilter.vue"),
    "select-checkbox-filter": () =>
      import("@/components/app/global/dataFilters/selectCheckboxFilter.vue"),
    "select-radio-filter": () =>
      import("@/components/app/global/dataFilters/selectRadioFilter.vue"),
    "select-filter": () =>
      import("@/components/app/global/dataFilters/selectFilter.vue"),
    "select-multi-filter": () =>
      import("@/components/app/global/dataFilters/selectMultiFilter.vue"),
    "date-filter": () =>
      import("@/components/app/global/dataFilters/dateFilter.vue"),
    "tags-filter": () =>
      import("@/components/app/global/dataFilters/tagsFilter.vue")
  }
})
export default class FilterInput extends Vue {
  @Prop({ required: true })
  public value!: string;

  @Prop({ required: true })
  public options!: IFiltersOptions[];

  @Prop({ required: true })
  public fieldName!: string;

  @Prop({ required: true })
  public fieldId!: string;

  @Prop({ required: true })
  public type!: FilterTypes;

  @Prop({ default: false })
  public disabled!: boolean;

  @Prop({ default: false })
  public isRequired!: boolean;

  @Prop({ default: false })
  public relative!: boolean;

  @Prop({ default: "" })
  public placeholder!: string;

  @Prop({ default: false })
  public sameLine!: boolean;

  @Prop({ default: true })
  public multiselectsOpen!: boolean;

  public get isStringFilter() {
    return this.type === FilterTypes.STRING;
  }

  public get isDateFilter() {
    return this.type === FilterTypes.DATE;
  }

  public get isSelectCheckboxFilter() {
    return this.type === FilterTypes.SELECT_CHECKBOX;
  }

  public get isNumberFilter() {
    return this.type === FilterTypes.NUMBER;
  }

  public get isSelectRadioFilter() {
    return this.type === FilterTypes.SELECT_RADIO;
  }

  public get isTagFilter() {
    return this.type === FilterTypes.TAG;
  }

  public get isSelectFilter() {
    return this.type === FilterTypes.SELECT;
  }

  public get isMultiSelectFilter() {
    return this.type === FilterTypes.SELECT_MULTI;
  }
}
